module.exports = __webpack_public_path__ + "media/Emergency1.9a5ad68e.mp3";